import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import App from "./App";
import TrackOrder from "./pages/TrackOrder";
import Contact from "./pages/Contact";
import Account from "./pages/Account";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminGuard from "./pages/admin/AdminGuard";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Orders from "./pages/admin/Orders";
import Sessions from "./pages/admin/Sessions";
import Recipes from "./pages/admin/Recipes";
import RecipeDetail from "./pages/admin/RecipeDetail";
import Settings from "./pages/admin/Settings";
import Reports from "./pages/admin/Reports";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <Routes>
      {/* Student routes */}
      <Route path="/" element={<App />} />
      <Route path="/track" element={<TrackOrder />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/account" element={<Account />} />

      {/* Admin login — public */}
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Admin routes — protected */}
      <Route
        path="/admin"
        element={
          <AdminGuard>
            <AdminLayout />
          </AdminGuard>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="recipes" element={<Recipes />} />
        <Route path="recipes/:id" element={<RecipeDetail />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  </Router>
);